import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHeader, Divider } from '_template';
import Breadcrumbs from 'components/Breadcrumbs';
import Helmet from 'components/Helmet';
import Actions from './components/Actions';
import TaxDocumentTable from './components/TaxDocumentTable';
import LimitedAccess from 'components/LimitedAccess';
import { RIGHTS } from 'constants/rights';

const TaxDocumentList = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t<string>('TAX_DOCUMENT.MODEL_TITLE')} />
      <ContentHeader
        title={t('TAX_DOCUMENT.MODEL_TITLE')}
        actions={<Actions />}
        breadcrumbs={<Breadcrumbs section={t('TAX_DOCUMENT.MODEL_TITLE')} />}
      />
      <Divider sx={{ my: 4 }} />
      <LimitedAccess right={RIGHTS.TAX_DOCUMENT.LIST}>
        <TaxDocumentTable />
      </LimitedAccess>
    </>
  );
};

export default TaxDocumentList;
